"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listCV = void 0;
const clarityValue_1 = require("../clarityValue");
function listCV(values) {
    return { type: clarityValue_1.ClarityType.List, list: values };
}
exports.listCV = listCV;
//# sourceMappingURL=listCV.js.map